import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { BulkProposalCard } from './BulkProposalCard';
import type { PartnerCandidateRow } from './proposal-part.types';

interface Props {
  proposalId: string;
  rows: PartnerCandidateRow[];
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/** Confirmation card for a bulk add-partners proposal — lists every company to be created. */
export function AddPartnersProposalCard({
  proposalId,
  rows,
  resolved,
  onConfirm,
  onCancel
}: Props) {
  const t = useFeatureTranslation('aiChat');

  return (
    <BulkProposalCard
      title={t('proposals.add-partners.title')}
      description={t('proposals.add-partners.countDescription', { count: rows.length })}
      proposalId={proposalId}
      rows={rows}
      rowKey={row => row.companyId}
      primary={row => row.name}
      secondary={row => (
        <span className='text-foreground-muted'>
          {row.city ? `${row.city} · ${row.companyId}` : row.companyId}
        </span>
      )}
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
